<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						我推广的
					</div>
					<div style="padding: 20px;color: #fff;" class="form">
						<div style="font-size: 16px;">
							我的推广链接：
						</div>
						<div style="font-size: 16px;margin-top: 5px;">
							<div>{{url}}</div>
							
						</div>
						<div class="t-header">
							<div class="t-item">
								开发者ID
							</div>
							<div class="t-item">
								充值金额
							</div>
						</div>
						<div class="t-body" v-for="(item,index) in list" :key="index">
							<div class="t-item">
								{{item.id}}
							</div>
							<div class="t-item">
								{{(item.api_charge_amount_count/100).toFixed(2)}}
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						推广说明
					</div>
					<div style="padding: 20px;font-size: 14px;" class="form" v-if="count_info">
						<div style="font-size: 16px;">
						 1.您的推广奖励天数可兑换给除了您的推荐人和被您推荐的任何人
						</div>
						<div style="font-size: 16px;margin-top: 15px;">
							2.兑换后立即生效，请谨慎操作。
						</div>
						<div style="font-size: 16px;margin-top: 15px;">
							3.您推广的用户共计充值了{{count_info.downer_count_charge/100}}元，您共计可兑换api时长{{count_info.downer_count_charge/100/count_info.exchange_rate}}
						</div>
						
						<div style="font-size: 16px;margin-top: 15px;">
							4.您已兑换了{{count_info.my_used.times}}次，消耗了{{(count_info.my_used.amount/100*count_info.exchange_rate*5).toFixed(2)}}天的可兑换时长。
						</div>
						<div style="font-size: 16px;margin-top: 15px;">
							5.您当前可兑换{{(count_info.downer_count_charge-count_info.my_used.amount*5)/100/count_info.exchange_rate}}天api时长
						</div>
					
						
					</div>
				</div>
				<div class="centext-box" style="margin-top: 20px;">
					<div class="header">
						推广兑换
					</div>
					<div style="padding: 20px;font-size: 14px;color: #ccc;" class="form" >
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="兑换人ID" prop="center_id">
								<el-input type="text" :placeholder="'您的开发者ID是'+user.center_id" size="small" v-model="ruleForm.center_id"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="兑换数量(天)" prop="days">
								<el-input 
									type="numer" 
									min="0" 
									:placeholder="'共计可兑换'+(downer_count_charge-amount*5)/100/exchange_rate+'天'"
									size="small"
									v-model="ruleForm.days" style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" size="small" @click="do_excharge('ruleForm')">立即兑换</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		computed:{
			...mapState({
				user:state=>state.user
			})
		},
		data() {
			return {
				url:'',
				downer_count_charge: 0,
				exchange_rate: 0,
				amount: 0,
				times: 0,
				list: [],
				ruleForm: {
					center_id: '',
					days: ''
				},
				count_info:null,
				rules: {
					center_id: [{
						required: true,
						message: '请输入开发者ID',
						trigger: 'blur'
					}],
					days: [{
						required: true,
						message: '请输入兑换数量',
						trigger: 'blur'
					}],
				},
			}
		},
		created() {
			this.getData()
			console.log(this.user)
			
		},
		mounted() {
			if(this.user){
				this.url = 'http://quanlang.top/recommend/'+this.user.center_id
			}
			
		},
		methods: {
			do_excharge() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$H.post('verify_center/v1_0_1.Center/RecommendExcharge', this.ruleForm, true).then(
							res => {
								if (res.data) {
									this.$message.success('兑换成功')
									this.getData()
								}
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			getData() {
				this.$H.post('/verify_center/v1_0_1.Center/MyRecommend', {
					page: 1
				}).then(res => {
					if (res.data) {
						this.count_info = res.data.count_info
						this.downer_count_charge = res.data.count_info.downer_count_charge
						this.exchange_rate = res.data.count_info.exchange_rate
						this.amount = res.data.count_info.my_used.amount
						this.times = res.data.count_info.my_used.times
						this.list = res.data.list.data
						console.log(this.list)
					}
				})
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.t-header {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: 700;
		display: flex;
	}

	.t-body {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: normal;
		display: flex;
	}

	.t-item {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>